import { handleActions } from 'redux-actions';
import { PARTITION, actionTypes, ACTION_PREFIX } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { Account, SupplierBuyerAssociation } from '../../types';

export interface ReduxState {
  accounts?: Account[];
  supplierBuyerAssociation?: SupplierBuyerAssociation;
  selectedAccount?: Account;
  redirectUrl: string;
}

const initialState: ReduxState = {
  accounts: [],
  supplierBuyerAssociation: undefined,
  selectedAccount: undefined,
  redirectUrl: '',
};

const reducer = handleActions(
  {
    [actionTypes.GET_ACCOUNTS_FULFILLED]: (state: any, { payload }) => ({
      ...state,
      accounts: payload.data.accounts,
    }),
    [actionTypes.GET_SUPPLIER_BUYER_ASSOCIATION_FULFILLED]: (state: any, { payload }) => ({
      ...state,
      supplierBuyerAssociation: payload.data,
    }),
    [actionTypes.SET_SELECTED_ACCOUNT]: (state: any, { payload }) => ({
      ...state,
      selectedAccount: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
